import type { DeviationJustificationFormProps } from './types'

export const initialFormValues: DeviationJustificationFormProps = {
  economicGroup: '',
  profitCenter: '',
  account: '',
  budget: '',
  actualPreview: '',
  deviationVsBudget: '',
  deviationVsBudgetPercentage: '',
  deviationTypeBudget: '',
  observationsBudget: '',
  previewWeek: '',
  actualPreviewWeek: '',
  deviationVsPreviewWeek: '',
  deviationVsPreviewWeekPercentage: '',
  deviationTypeWeek: '',
  observationsWeek: ''
}
